export default "__VITE_ASSET__BxwAjtH1__"